import React, { useEffect, useState } from "react";
import { Button } from "baseui/button";
import { useStyletron } from "baseui";
import logoImage from "../logoImage2.png";
import logoImage2 from "../logo2.png";
import { Link } from "react-scroll";
import galleryEvents from "../data/galleryEvents.json";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [css] = useStyletron();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 760);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isHomePage = !window.location.pathname.startsWith("/shop") && window.location.pathname !== "/checkout";

  const handleCloseDrawer = () => setDrawerOpen(false);

  const handleHomeClick = (event) => {
    handleCloseDrawer();

    if (window.location.pathname === "/") {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  const scrollToSection = (id) => {
    const target = document.getElementById(id);
    if (!target) return;

    const headerHeight =
      document.querySelector(".apt300-header")?.getBoundingClientRect().height || 0;
    const targetTop =
      window.pageYOffset + target.getBoundingClientRect().top - headerHeight - 16;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: "auto",
    });
  };

  const handleGalleryEventClick = (eventKey) => {
    if (!isHomePage) {
      window.location.href = `/#gallery-event-${eventKey}`;
      return;
    }
    scrollToSection(`gallery-event-${eventKey}`);
    handleCloseDrawer();
  };

  const renderSectionLink = (label, id, mobile = false) => {
    if (!isHomePage) {
      return <a href={`/#${id}`} style={mobile ? linkStyle : undefined} className={mobile ? undefined : "apt300-nav-link"} onClick={mobile ? handleCloseDrawer : undefined}>{label}</a>;
    }
    return <Link to={id} smooth={true} duration={500} style={mobile ? linkStyle : undefined} className={mobile ? undefined : "apt300-nav-link"} onClick={mobile ? handleCloseDrawer : undefined}>{label}</Link>;
  };

  const renderTicketLink = (mobile = false) => {
    const button = <Button className={headerButtonStyles} style={{ margin: "10px 20px" }}>Buy Tickets</Button>;
    if (!isHomePage) return <a href="/#ticketList" onClick={mobile ? handleCloseDrawer : undefined}>{button}</a>;
    return <Link to="ticketList" smooth={true} duration={500} onClick={mobile ? handleCloseDrawer : undefined}>{button}</Link>;
  };

  const closeButtonStyles = {
    display: isMobile && drawerOpen ? "block" : "none",
    backgroundColor: "white",
    borderRadius: "5px",
    padding: "10px 15px",
    fontSize: "1.5rem",
    fontWeight: "bold",
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
  };

  const drawerStyles = {
    display: drawerOpen ? "block" : "none",
  };

  const headerButtonStyles = css({
    fontFamily: "Impact, sans-serif",
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "0.5rem 2rem",
    borderRadius: "30px",
    backgroundColor: "#EA2B1F",
    backgroundImage: "linear-gradient(180deg, #E59F71, #D23C1B)",
    color: "#000",
    ":hover": {
      backgroundColor: "#EDAE49",
      backgroundImage: "linear-gradient(180deg, #D23C1B, #E59F71)",
    },
  });

  const linkStyle = {
    color: "black",
    textDecoration: "none",
    padding: "10px 20px",
    cursor: "pointer",
  };

  const renderGalleryEvents = (mobile = false) => (
    <div
      className={mobile ? "apt300-mobile-gallery-menu" : "apt300-gallery-nav-item"}
    >
      <button
        type="button"
        className={mobile ? "apt300-mobile-gallery-link" : "apt300-nav-link"}
        style={mobile ? linkStyle : undefined}
        onClick={() => {
          if (!isHomePage) {
            window.location.href = "/#gallery";
            return;
          }
          scrollToSection("gallery");
          if (mobile) handleCloseDrawer();
        }}
      >
        Gallery
      </button>
      <div
        className="apt300-gallery-submenu"
        aria-label="APT 300 gallery events"
      >
        {galleryEvents.map((event) => (
          <button
            type="button"
            className="apt300-gallery-submenu-link"
            onClick={() => handleGalleryEventClick(event.key)}
          >
            <span className="apt300-gallery-submenu-name">{event.name}</span>
            <span className="apt300-gallery-submenu-meta">
              {event.city} · {event.date}
            </span>
            {event.dressCode && (
              <span className="apt300-gallery-submenu-meta">
                Dress code: {event.dressCode}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <header id="top" className="apt300-header">
        <a
          href="/#top"
          className="apt300-logo-button"
          onClick={handleHomeClick}
          aria-label="Go to the APT 300 home page"
        >
          <img
            src={logoImage}
            alt="APT 300"
            className="apt300-header-logo"
          />
        </a>

        <nav className="apt300-desktop-nav" aria-label="Primary navigation">
        {renderSectionLink("Playlist", "playlist")}
          {renderGalleryEvents()}
          <a href="/shop" className="apt300-nav-link">Shop</a>
          {renderSectionLink("Contact APT 300", "contact")}
          {renderSectionLink("APT 300 on YouTube", "riskiOnYoutube")}
          {renderTicketLink()}
        </nav>

        <button
          type="button"
          className="apt300-menu-button"
          onClick={() => setDrawerOpen((open) => !open)}
          aria-label="Open navigation menu"
          aria-expanded={drawerOpen}
        >
          ☰
        </button>
      </header>

      {drawerOpen && (
        <button
          type="button"
          className="apt300-drawer-backdrop"
          onClick={handleCloseDrawer}
          aria-label="Close navigation menu"
        />
      )}
      <div
        className="apt300-mobile-drawer"
        style={drawerStyles}
        aria-hidden={!drawerOpen}
      >
        <button
          type="button"
          onClick={handleCloseDrawer}
          style={closeButtonStyles}
          aria-label="Close navigation menu"
        >
          ×
        </button>
        <nav
          className="apt300-mobile-nav"
          aria-label="Mobile navigation"
        >
          <a
            href="/#top"
            className="apt300-logo-button apt300-mobile-logo-button"
            onClick={handleHomeClick}
            aria-label="Go to the APT 300 home page"
          >
            <img src={logoImage2} alt="APT 300" className="apt300-mobile-logo" />
          </a>
          {renderSectionLink("Playlist", "playlist", true)}
          {renderGalleryEvents(true)}
          <a href="/shop" style={linkStyle} onClick={handleCloseDrawer}>Shop</a>
          {renderSectionLink("Contact APT 300", "contact", true)}
          {renderSectionLink("APT 300 on YouTube", "riskiOnYoutube", true)}
          {renderTicketLink(true)}
        </nav>
      </div>
    </>
  );
};

export default Header;
